<div class="table-container">
  <!-- Header Section -->
  <div class="table-header">
    <div class="search-section" *ngIf="searchable">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon">search</mat-icon>
        <input 
          type="text" 
          class="search-input" 
          [placeholder]="searchPlaceholder"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearch($event)">
      </div>
      
      <!-- Filters inline with search -->
      <ng-container *ngIf="showFilters">
        <ng-container *ngFor="let column of columns">
          <div 
            *ngIf="column.filterable && column.filterOptions"
            class="custom-select"
            [class.open]="openDropdown === column.field">
            
            <div class="select-trigger" (click)="toggleDropdown(column.field)">
              <span 
                class="selected-text"
                [class.placeholder]="!filters[column.field] || filters[column.field] === 'All'">
                {{getFilterDisplayText(column)}}
              </span>
              <span class="arrow">▼</span>
            </div>
            
            <div class="select-options" *ngIf="openDropdown === column.field">
              <div 
                class="option"
                [class.selected]="filters[column.field] === 'All' || !filters[column.field]"
                (click)="selectOption(column.field, 'All')">
                All
              </div>
              <div 
                class="option"
                [class.selected]="filters[column.field] === getFilterOptionValue(option)"
                *ngFor="let option of column.filterOptions"
                (click)="selectOption(column.field, getFilterOptionValue(option))">
                {{ getFilterOptionLabel(option) }}
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      
      <button class="search-btn" (click)="refreshData()">
        <mat-icon>refresh</mat-icon>
      </button>
      <button class="add-btn" *ngIf="showAddButton" (click)="onAdd()">
        <mat-icon>add_circle</mat-icon>
        {{ addButtonText }}
      </button>
      <button class="add-btn" *ngFor="let btn of addButtons" (click)="onAddButton(btn)">
        <mat-icon>add_circle</mat-icon>
        {{ btn.text }}
      </button>
      <button class="nav-btn" *ngIf="showNavButton" (click)="onNav()">
        <mat-icon>arrow_back</mat-icon>
        {{ navButtonText }}
      </button>
    </div>
    <div class="download-wrapper" *ngIf="showDownload">
      <button class="download-btn" (click)="toggleDownloadMenu()">
        <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M480-313 287-506l43-43 120 120v-371h60v371l120-120 43 43-193 193ZM220-160q-24 0-42-18t-18-42v-143h60v143h520v-143h60v143q0 24-18 42t-42 18H220Z"/></svg>
      </button>
      <div class="download-menu" *ngIf="showDownloadMenu">
        <button class="menu-item" *ngIf="showExcelDownload" (click)="onDownloadExcel()">Excel</button>
        <button class="menu-item" *ngIf="showPdfDownload" (click)="onDownloadPdf()">PDF</button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <table class="data-table">
    <thead>
      <tr>
        <!-- <th *ngIf="selectable" class="checkbox-col">
          <input 
            type="checkbox" 
            [checked]="allSelected"
            (change)="toggleSelectAll()">
        </th> -->
        <th *ngFor="let column of columns" [class.sortable]="column.sortable">
          {{ column.header }}
        </th>
        <th *ngIf="actions.length > 0">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of paginatedData">
        <!-- <td *ngIf="selectable" class="checkbox-col">
          <input 
            type="checkbox" 
            [checked]="isSelected(row)"
            (change)="toggleRow(row)">
        </td> -->
        <td *ngFor="let column of columns">
          <ng-container *ngIf="column.template; else defaultCell">
            <ng-container *ngTemplateOutlet="column.template; context: { $implicit: row }">
            </ng-container>
          </ng-container>
          <ng-template #defaultCell>
            {{ row[column.field] }}
          </ng-template>
        </td>
        <td *ngIf="actions.length > 0" class="actions-col">
          <button 
            *ngFor="let action of actions"
            [hidden]="action.condition && !action.condition(row)"
            [class.action-btn]="action.icon"
            [class.action-text-btn]="action.text"
            [style.color]="action.color"
            [style.border-color]="action.bordered ? (action.borderColor || action.color) : 'transparent'"
            [title]="action.tooltip"
            (click)="executeAction(action, row)">
            <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
            <span *ngIf="action.text">{{ getActionText(action, row) }}</span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Footer -->
  <div class="table-footer" *ngIf="pagination">
    <div class="selection-info">
      Total: {{ serverSide ? totalItems : filteredData.length }} row(s)
    </div>
    <div class="pagination">
      <button 
        class="pagination-btn" 
        [disabled]="currentPage === 1"
        (click)="previousPage()">
        Previous
      </button>
      <span *ngIf="totalPages > 0">Page {{ currentPage }} of {{ totalPages }}</span>
      <button 
        class="pagination-btn" 
        [disabled]="totalPages === 0 || currentPage >= totalPages"
        (click)="nextPage()">
        Next
      </button>
    </div>
  </div>
</div>
